module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "an"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ATA"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_an",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")])]), _vm._v(" "), _c('p', {
    staticClass: "ATX"
  }, [_vm._v("The author thanks Abdul Aziz Froutan and colleagues in Afghanistan, as well as members of the Royal Irish Regiment, who have been answering his questions since he began "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Illuminations")]), _vm._v(" in 2010. Thanks also to Yaddo, and to Mary O’Connor and the keepers of the Joseph Mulholland Archive at McMaster University in Hamilton, Ontario, where he studied the papers of the photographer Margaret Watkins.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-124e41c9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/authorsnote.vue
// module id = 72
// module chunks = 0